export var OffCanvasSizeEnumValues;
(function (OffCanvasSizeEnumValues) {
    OffCanvasSizeEnumValues["SIZE_100"] = "100";
    OffCanvasSizeEnumValues["SIZE_60"] = "60";
    OffCanvasSizeEnumValues["SIZE_30"] = "30";
})(OffCanvasSizeEnumValues || (OffCanvasSizeEnumValues = {}));
